import { Restrictions } from 'shared/api/MyTicketsModel'
import { Segment } from 'shared/models/ticket'

export enum PromoContentType {
  TEXT = 'TEXT',
  AIRLINE = 'AIRLINE',
}

export enum PromoUrlType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  MBANK_DEEPLINK = 'MBANK_DEEPLINK',
  PDF = 'PDF',
}

export interface TextContent {
  text: string
  image?: string | null
  content_type?: PromoContentType.TEXT
}

export interface AirlineContent {
  from_city: string
  to_city: string
  airline: string
  price: string
  old_price: string
  content_type: PromoContentType.AIRLINE
  search_filter_body: SearchFilterBody
  logo_url: string
}

export interface SearchFilterBody {
  directions: Direction[]
  airline_codes: string[]
}

export interface Direction {
  date: string
  from: string
  to: string
}

export type PromoContent = TextContent | AirlineContent

export interface PromoModel {
  id: string
  title?: string
  content?: PromoContent[]
  baner?: string
  button_text?: string
  url_type?: PromoUrlType
  redirect_url?: string
  file?: string
}

export interface IPopularRoutesAvia {
  arr: PopularRoutesItem
  dep: PopularRoutesItem
  start_price: number
  city_logo: string
  date: string
}

export interface PopularRoutesItem {
  airport: Airport
  city: City
  country: string
  logo: string
}

export interface Airport {
  title: string
  code: string
}

export interface City {
  code: string
  title: string
}

export interface ActiveTicketBought {
  id: string
  billing_number?: number
  departure_datetime?: string
  departure_datetime_utc?: string
  ticket_receipt_url?: string
  restrictions?: Restrictions[]
  flight_details: {
    flight: {
      type: string
      duration: number
      segments: Pick<Segment, 'arr' | 'dep' | 'is_online_checkin_required'>[]
    }
  }
}
